import actions from './actions';
import mutations from './mutations';

const initialState = () => {
  return {
    total: 0,
    loadingAction: {
      ...Object.keys(actions).reduce((obj, action) => {
        return { ...obj, [action]: false };
      }, {})
    },
    errorAction: {
      ...Object.keys(actions).reduce((obj, action) => {
        return { ...obj, [action]: false };
      }, {})
    },
    progressAction: {
      ...Object.keys(actions).reduce((obj, action) => {
        return { ...obj, [action]: false };
      }, {})
    },
    invoiceCaptures: [],
    invoiceCapture: {},
    listFilters: {
      $sort: 'createdAt:-1'
    }
  };
};

const store = {
  namespaced: true,
  state: initialState(),
  getters: {
    loadingAction: state => state.loadingAction,
    errorAction: state => state.errorAction,
    progressAction: state => state.progressAction,
    validationErrors: state => state.validationErrors,
    total: state => state.total,
    invoiceCaptures: state => state.invoiceCaptures,
    invoiceCapture: state => state.invoiceCapture,
    captureQueue: state => {
      return state.invoiceCaptures.filter(invoiceCapture => invoiceCapture.status === 'captured' && !invoiceCapture.invoiceValidationId);
    },
    invoiceResults: state => {
      if (!state.invoiceCapture || !state.invoiceCapture.results) return [];

      const invoices = state.invoiceCapture.results.multiInvoice?.invoices || [];

      return invoices;
    },
    meterResults: state => {
      if (!state.invoiceCapture || !state.invoiceCapture.results) return [];

      const meterKeys = Object.keys(state.invoiceCapture.results).filter(key => key.startsWith(`multiMeter`));

      const meterResults = meterKeys.reduce((acc, key) => {
        // Key format: multiMeter-i1-water
        const result = state.invoiceCapture.results[key];

        const extractNumber = key.match(/multiMeter-i(\d+)-\w+/);
        const invoiceIndex = extractNumber ? parseInt(extractNumber[1], 10) : null;

        if (invoiceIndex === null || !result || !result.meters) {
          console.warn(`Invalid meter key: ${key}`);
          return acc;
        }

        acc.push(...result.meters.map(m => ({ ...m, invoiceIndex })));

        return acc;
      }, []);

      const comments = meterKeys.map(key => {
        const result = state.invoiceCapture.results[key];

        return result.comment;
      });

      const meters = meterResults.map(m => {
        const suffix = `${m.utilityType}-m${m.index}`;

        const multiMeterKey = `multiMeter-i${m.invoiceIndex}-${m.utilityType}`;
        const meterValuesKey = `extractMeterValues-i${m.invoiceIndex}-${suffix}`;
        const valueResults = state.invoiceCapture.results[meterValuesKey];
        const ratesResults = state.invoiceCapture.results[`extractRates-i${m.invoiceIndex}-${suffix}`];
        const readingsResults = state.invoiceCapture.results[`extractReadings-i${m.invoiceIndex}-${suffix}`];

        return { ...m, id: `${m.invoiceIndex}-${suffix}`, meterValuesKey, multiMeterKey, ratesResults, valueResults, readingsResults };
      });

      return {
        comment: comments.join('\n\n'),
        meters
      };
    }
  },
  mutations: {
    RESET_STATE: state => {
      Object.assign(state, initialState());
    },
    ...mutations
  },
  actions: {
    ...actions
  }
};

export default store;
